import { render, staticRenderFns } from "./SellLimits.vue?vue&type=template&id=ba6872f8&"
import script from "./SellLimits.vue?vue&type=script&lang=js&"
export * from "./SellLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports